import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import RadioButtonWithLabel from 'chameleon/ui-stack/ui/basic/radio-button-with-label';
import {
  INCLUDE_FILTER,
  INCLUDE_ONLY_FILTER,
  EXCLUDE_HIGHER_FILTER,
} from 'chameleon-src/constants/filters';

const getTexts = (tagCategoryDescription) => {
  const type =
    tagCategoryDescription.toLowerCase() === 'unit and topic'
      ? 'Units or Topics'
      : 'Units';

  return {
    [EXCLUDE_HIGHER_FILTER]: `Include questions tagged with at least one of the selected ${type}, but exclude questions tagged with content presented later in the CED.`,
    [INCLUDE_ONLY_FILTER]:
      'Include questions only tagged with one or more of these selections:',
    [INCLUDE_FILTER]:
      'Include questions tagged with at least one of these selections:',
  };
};

const InclusionFilters = (props) => {
  const {
    selectedType,
    onChange,
    hasExcludeHigherFilter,
    tagCategoryDescription,
  } = props;
  const texts = getTexts(tagCategoryDescription);
  const visibleHelpText = texts[selectedType];

  return (
    <div className="flex flex-col px-6 py-4.4 border-bottom space-y-6">
      <div
        className={cn('flex items-center space-x-8', {
          'justify-center': !hasExcludeHigherFilter,
        })}
      >
        <RadioButtonWithLabel
          wrapText={false}
          className="whitespace-nowrap"
          checked={selectedType === INCLUDE_FILTER}
          onClick={() => onChange(INCLUDE_FILTER)}
          label="Include"
          accessibility={{
            ariaLabel: `Include. ${texts[INCLUDE_FILTER]}`,
          }}
        />
        {hasExcludeHigherFilter && (
          <RadioButtonWithLabel
            wrapText={false}
            checked={selectedType === EXCLUDE_HIGHER_FILTER}
            onClick={() => onChange(EXCLUDE_HIGHER_FILTER)}
            label="Include No Later Than"
            accessibility={{
              ariaLabel: `Include No Later Than. ${texts[EXCLUDE_HIGHER_FILTER]}`,
            }}
          />
        )}
        <RadioButtonWithLabel
          wrapText={false}
          className="whitespace-nowrap"
          checked={selectedType === INCLUDE_ONLY_FILTER}
          onClick={() => onChange(INCLUDE_ONLY_FILTER)}
          label="Include Only"
          accessibility={{
            ariaLabel: `Include Only. ${texts[INCLUDE_ONLY_FILTER]}`,
          }}
        />
      </div>
      <div className="text-14 text-gray-700 leading-8">{visibleHelpText}</div>
    </div>
  );
};

InclusionFilters.propTypes = {
  selectedType: PropTypes.oneOf([
    INCLUDE_FILTER,
    INCLUDE_ONLY_FILTER,
    EXCLUDE_HIGHER_FILTER,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  hasExcludeHigherFilter: PropTypes.bool,
  tagCategoryDescription: PropTypes.string.isRequired,
};

InclusionFilters.defaultProps = {
  hasExcludeHigherFilter: false,
};

export default InclusionFilters;
